
import { computed, defineComponent, PropType } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { SecurityPersonInformation } from '@/core/types/security.types'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        person: {
            type: Object as PropType<SecurityPersonInformation>,
            required: true,
        },
        isDeclineLoading: {
            type: Boolean,
            default: false,
        },
        isConfirmLoading: {
            type: Boolean,
            default: false,
        },
        isCanConfirm: {
            type: Boolean,
            default: false,
        },
        isCanDecline: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['decline', 'confirm'],
    setup(props, { emit }) {
        const onDecline = () => {
            emit('decline', props.person)
        }

        const onConfirm = () => {
            // const answer = confirm(
            //     `Вы действительно хотите разрешить физ. лицу ${
            //         props.person ? props.person.name : ''
            //     }?`
            // )
            // if (!answer) return

            emit('confirm', props.person)
        }

        const courtCaseProblems = computed(() => {
            let problems = [] as string[]

            if (props.person.courtCase.totalAdministrativeCount)
                problems.push(
                    `Общее количество административных дел: ${props.person.courtCase.totalAdministrativeCount}`
                )
            if (props.person.courtCase.totalCivilCount)
                problems.push(
                    `Общее количество гражданских дел: ${props.person.courtCase.totalCivilCount}`
                )
            if (props.person.courtCase.totalCriminalCount)
                problems.push(
                    `Общее количество уголовных дел: ${props.person.courtCase.totalCivilCount}`
                )

            return problems
        })

        const reliabilityFlProblems = computed(() => {
            let problems = [] as string[]

            if (props.person.reliabilityFl.alimonyPayer) problems.push('В базе алиментщиков')
            if (props.person.reliabilityFl.banLeaving) problems.push('Запрет на выезд')
            if (props.person.reliabilityFl.banNotariusActions)
                problems.push('Запрет на совершение нотариальных действий')
            if (props.person.reliabilityFl.banRegistrationActionsLegalEnt)
                problems.push('Запрет на регистрационные действия ЮЛ')
            if (props.person.reliabilityFl.banRegistrationActionsPhysicalEnt)
                problems.push('Запрет на регистрационные действия ФЛ')
            if (props.person.reliabilityFl.banSeizedPropertyActions)
                problems.push('Запрет на реализацию арестованного имущества')
            if (props.person.reliabilityFl.citizenHidingFromInvestigation)
                problems.push('В базе граждан, скрывающихся от следствий')
            if (props.person.reliabilityFl.debtorForExecutiveDocuments)
                problems.push('В базе должников по исполнительным документам')
            if (props.person.reliabilityFl.enforcementDebt)
                problems.push('Задолженность по исполнительным производствам')
            if (props.person.reliabilityFl.missing) problems.push('В базе провавших без вести')
            if (props.person.reliabilityFl.pedophile) problems.push('В базе педофилов')
            if (props.person.reliabilityFl.seizedBankAccount)
                problems.push('Арест на банковский счет')
            if (props.person.reliabilityFl.seizedProperty) problems.push('Арест на имущество')
            if (Number(props.person.reliabilityFl.taxDebt))
                problems.push(
                    `Сумма задолженности по налогам и таможенным платежам: ${props.person.reliabilityFl.taxDebt}`
                )
            if (props.person.reliabilityFl.terrorist)
                problems.push('Связан с финансированием терроризма')

            return problems
        })

        const isRenderProblems = computed(
            () => courtCaseProblems.value.length || reliabilityFlProblems.value.length
        )

        return {
            onDecline,
            onConfirm,
            courtCaseProblems,
            reliabilityFlProblems,
            isRenderProblems,
        }
    },
})
